import { render, staticRenderFns } from "./AdminPromo.vue?vue&type=template&id=208382f7&"
import script from "./AdminPromo.vue?vue&type=script&lang=js&"
export * from "./AdminPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports